import { render, staticRenderFns } from "./MoreStripe.vue?vue&type=template&id=3585fc3a&scoped=true"
import script from "./MoreStripe.vue?vue&type=script&lang=js"
export * from "./MoreStripe.vue?vue&type=script&lang=js"
import style0 from "./MoreStripe.vue?vue&type=style&index=0&id=3585fc3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3585fc3a",
  null
  
)

export default component.exports